import {decode} from '.';
import {map, first, cookies} from 'helpers';
import {ServerData, Models} from './types';
import {Actions} from 'store/action.type';

export const notify = (response: ServerData, existingElementIds: Record<Models, string>) => ({
  type: 'SERVER_DATA_RECEIVED' as const,
  activities: response.activities.map(decode.activity),
  categorizedHabitTypes: response.categorizedHabitTypes || [],
  collaborators: response.collaborators,
  emotionsMeter: response.emotionsMeter.map(decode.emotionsMeter),
  existingElementIds,
  files: response.files.map(decode.file),
  goalProgress: response.goalProgress.map(decode.goalProgress),
  goals: response.goals,
  goalTypes: map(response.goalTypes, decode.goalType),
  gptConnects: response.gptConnects,
  journals: response.journals.map(decode.journal),
  notes: map(response.notes, decode.note),
  noteTypes: map(response.noteTypes, decode.noteType),
  questions: response.questions,
  relations: response.relations,
  serverExistingElementIds: response.existingElementIds,
  serverTime: response.serverTime,
  settings: first(response.settings) || response.settings || {},
  sortingInfo: response.sortingInfo,
  statuses: response.statuses.map(decode.status),
  subTasks: response.subTasks || [],
  tags: response.tags.map(decode.tag),
  token: cookies.get('token'),
  units: response.units,
  lists: response.lists.map(decode.list),
  listItems: response.listItems.map(decode.listItem),
});

export const notified = () => ({
  type: 'SERVER_DATA_RECEIVED_AFTER' as const
});

export const read = (full = false) => ({
  type: 'SERVER_READ' as const,
  full
});

const deleteAll = () => ({
  type: 'TESTING_DELETE_ALL' as const
});

const actions = {read, notify, notified, deleteAll};

export type ServerActions = Actions<typeof actions>
